import React from 'react';

import '../styles/SplashScreen.css';

interface SplashScreenProps {
  logo?: JSX.Element;
  org?: string;
}

const SplashScreen = (props: SplashScreenProps) => {
  return (
    <div className="splash">
      <div className="splash-centered-panel">
      {
        props.logo
        &&
        <div className="logo-panel blur">
          {props.logo}
        </div>
      }
      {
        props.org
        &&
        <div className="org blur">
          {props.org}
        </div>
      }
      </div>
    </div>
  )
}

export default SplashScreen;
